// staleStore — #786. A tiny external store (for useSyncExternalStore) tracking
// whether the most recent API response was served stale-while-revalidate (agent
// unreachable → cached KV data). Lives at the api.js choke point rather than
// per-page because hooks unwrap the response envelope, dropping the `_stale`
// flag before a page ever sees it. AppShell renders one banner from this.

let state = { stale: false, since: null };
const listeners = new Set();

/** @param {boolean} stale @param {string|null} [since] ISO cache timestamp. */
export function setStale(stale, since = null) {
  const nextSince = stale ? since : null;
  if (state.stale === stale && state.since === nextSince) return; // stable ref if unchanged
  state = { stale, since: nextSince };
  listeners.forEach((l) => l());
}

export function subscribeStale(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getStaleSnapshot() {
  return state;
}

// Test-only: reset between cases.
export function _resetStaleStore() {
  state = { stale: false, since: null };
}
